import { render, staticRenderFns } from "./popup-audit.vue?vue&type=template&id=064a8d57&scoped=true"
import script from "./popup-audit.vue?vue&type=script&lang=js"
export * from "./popup-audit.vue?vue&type=script&lang=js"
import style0 from "./popup-audit.vue?vue&type=style&index=0&id=064a8d57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064a8d57",
  null
  
)

export default component.exports